import { render } from "./recordListParent.vue?vue&type=template&id=6dd14f44&scoped=true"
import script from "./recordListParent.vue?vue&type=script&lang=js"
export * from "./recordListParent.vue?vue&type=script&lang=js"

import "./recordListParent.vue?vue&type=style&index=0&id=6dd14f44&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd14f44"]])

export default __exports__